import FormTitle from '@core/components/FormTitle';
import { FormControl, Grid, InputLabel, MenuItem, Select } from '@material-ui/core';
import React from 'react';
import CompraPagamentoAVista from './CompraPagamentoAVista';
import CompraPagamentoParcelado from './CompraPagamentoParcelado';

const CompraFormaPagamento = ({
  id,
  name,
  values,
  onChange,
  onBlur,
  errors,
  touched,
  onGerarParcelas,
  onChangeConta,
  onChangeDataPrimeiraParcela,
  onChangeCondicaoPagamento,
  submitCount,
  disabled,
  compraPaga,
  valorTotal,
  compraId,
}) => {
  return (
    <>
      <FormTitle title="Informações de pagamento" />
      <Grid container spacing={3}>
        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
          <p>A movimentação financeira referente a essa compra será adicionada no contas a pagar.</p>
        </Grid>
        <Grid item xs={12} sm={12} md={4} lg={4} xl={4}>
          <FormControl
            disabled={disabled || compraPaga}
            variant="outlined"
            style={{ width: '100%' }}
            error={!!errors?.condicaoPagamento}
          >
            <InputLabel id="condicao-pagamento">Condição de pagamento *</InputLabel>
            <Select
              id={`${id}.condicaoPagamento`}
              name={`${id}.condicaoPagamento`}
              value={values?.condicaoPagamento}
              onChange={onChangeCondicaoPagamento}
              onBlur={onBlur}
              labelId="condicao-pagamento"
              label="Condição de pagamento *"
            >
              <MenuItem value="A_VISTA">À vista</MenuItem>
              <MenuItem value="PARCELADO">Parcelado</MenuItem>
            </Select>
          </FormControl>
        </Grid>
        {values?.condicaoPagamento === 'A_VISTA' && (
          <CompraPagamentoAVista
            id={`${id}.avista`}
            name={`${name}.avista`}
            onChange={onChange}
            onBlur={onBlur}
            values={values?.avista}
            errors={errors?.avista}
            touched={touched?.avista}
            onChangeConta={onChangeConta}
            submitCount={submitCount}
            compraPaga={compraPaga}
            valorTotal={valorTotal}
            compraId={compraId}
          />
        )}
        {values?.condicaoPagamento === 'PARCELADO' && (
          <CompraPagamentoParcelado
            id={`${id}.parcelado`}
            name={`${name}.parcelado`}
            onChange={onChange}
            onBlur={onBlur}
            values={values?.parcelado}
            errors={errors?.parcelado}
            touched={touched?.parcelado}
            onGerarParcelas={onGerarParcelas}
            onChangeDataPrimeiraParcela={onChangeDataPrimeiraParcela}
            submitCount={submitCount}
            disabled={disabled}
            compraPaga={compraPaga}
          />
        )}
      </Grid>
    </>
  );
};

export default CompraFormaPagamento;
